import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const BK = process.env.REACT_APP_BACKEND_URL;

export default function SetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null); // null=loading, false=invalid
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${BK}/api/invite/${token}`).then((r) => setInfo(r.data)).catch(() => setInfo(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== pw2) return toast.error("Passwords do not match");
    setSaving(true);
    try {
      await axios.post(`${BK}/api/set-password`, { token, password: pw });
      toast.success("Password set — you can now sign in");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Could not set password");
    } finally { setSaving(false); }
  };

  if (info === null) return <div className="min-h-screen grid place-items-center text-cass-slate">Loading…</div>;
  if (info === false) return (
    <div className="min-h-screen grid place-items-center bg-cass-bone p-6">
      <div className="text-center max-w-sm">
        <h1 className="font-alt text-2xl font-bold text-cass-navy mb-2">Link expired</h1>
        <p className="text-sm text-cass-slate mb-4">This link is invalid or has expired. Ask an administrator for a new invite, or use "Forgot password" on the sign-in page.</p>
        <Button onClick={() => navigate("/login")} className="bg-cass-navy text-white" data-testid="sp-to-login">Go to sign in</Button>
      </div>
    </div>
  );

  const isReset = info.kind === "reset";
  return (
    <div className="min-h-screen grid place-items-center bg-cass-bone p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 bg-white p-8 rounded-xl border border-border" data-testid="set-password-form">
        <div>
          <h1 className="font-alt text-2xl font-bold text-cass-navy">{isReset ? "Reset your password" : "Welcome to CASS"}</h1>
          <p className="text-sm text-cass-slate mt-1">{isReset ? "Choose a new password for" : "Set a password to activate your account"} <span className="font-medium text-cass-navy">{info.email}</span></p>
        </div>
        <div className="space-y-2"><Label>New password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="sp-password" required /></div>
        <div className="space-y-2"><Label>Confirm password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="sp-password2" required /></div>
        <Button type="submit" disabled={saving} className="w-full bg-cass-navy text-white" data-testid="sp-submit">{saving ? "Saving…" : "Set password"}</Button>
      </form>
    </div>
  );
}
